<tg-toolbar tbclass="mat-toolbar-tg mat-toolbar-base flex !h-initial flex-row gap-2 sm:gap-3 py-3 md:py-0">
	<ng-template tgToolbarControls>
		<div
			class="flex flex-auto flex-col items-center justify-start gap-1 sm:flex-row sm:items-center sm:justify-start sm:gap-3"
		>
			<div
				*ngIf="viewDate$status | async as vd"
				class="flex flex-row items-center justify-start gap-1"
			>
				<button
					(click)="prev()"
					[disabled]="(this.isLoading$ | async) || minValidation"
					mat-icon-button
				>
					<mat-icon>chevron_left</mat-icon>
				</button>
				<button
					(click)="dayPickerPopover.toggle()"
					[disabled]="this.isLoading$ | async"
					[satPopoverAnchor]="dayPickerPopover"
					class="mt-1 space-x-1"
					mat-button
				>
					<ng-container *ngIf="vd.sameDay; else vdRange">
						<span>{{ vd.start | formatDate: 'EEEE' }}</span>
						<span>{{ vd.start | formatDate: 'PP' }}</span>
						<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
					</ng-container>
					<ng-template #vdRange>
						<span>{{ vd.start | formatDate: 'PP' }}- {{ vd.end | formatDate: 'PP' }}</span>
						<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
					</ng-template>
				</button>
				<button
					(click)="next()"
					[disabled]="this.isLoading$ | async"
					mat-icon-button
				>
					<mat-icon>chevron_right</mat-icon>
				</button>
				<button
					(click)="today()"
					[disabled]="(this.isLoading$ | async) || vd.isToday"
					class="mt-1"
					fxHide.lt-md
					mat-button
				>
					<mat-icon>today</mat-icon>
					<span class="ml-2">{{ 'timer.calendar.today' | translate }}</span>
				</button>
			</div>
			<div class="flex-auto"></div>
			<div class="flex flex-row items-center justify-start gap-2">
				<div
					(click)="$event.preventDefault(); $event.stopPropagation(); toggleRange()"
					class="mat-bg-3 mat-bg-5-hover flex h-10 cursor-pointer select-none items-center space-x-4 rounded px-2.5"
				>
					<mat-icon
						[class.opacity-60]="rangeType !== 'day'"
						[matTooltip]="'utils.dayView' | translate"
					>
						view_day
					</mat-icon>
					<mat-slide-toggle
						[checked]="rangeType === 'week'"
						color="primary"
					></mat-slide-toggle>
					<mat-icon
						[class.opacity-60]="rangeType !== 'week'"
						[matTooltip]="'utils.weekView' | translate"
					>
						view_week
					</mat-icon>
				</div>
				<button
					(click)="openFeedHiddenDialog()"
					[matTooltip]="'feed.hidden-items' | translate"
					*ngIf="filteredEntries$hasHidden | async"
					mat-icon-button
				>
					<mat-icon>visibility_off</mat-icon>
				</button>
				<button
					(click)="$event.preventDefault(); changeShowBooked()"
					[matTooltip]="'feed.booked.show' | translate"
					class="flex flex-row items-center justify-center"
					mat-icon-button
				>
					<ng-container *ngIf="!showBookedLoading; else loadingShowBooked">
						<mat-checkbox
							[checked]="this.showBooked$ | async"
							color="primary"
						></mat-checkbox>
					</ng-container>
					<ng-template #loadingShowBooked>
						<mat-spinner
							[diameter]="18"
							color="primary"
							mode="indeterminate"
						></mat-spinner>
					</ng-template>
				</button>
				<button
					[matTooltip]="'account.profile.feed-grant' | translate"
					[routerLink]="['feed-scopes']"
					mat-icon-button
				>
					<mat-icon>settings</mat-icon>
				</button>
				<button
					(click)="this.reloadCalendar()"
					[matTooltip]="'feed.refresh' | translate"
					*ngIf="!(this.isLoading$ | async); else reloadCalLoading"
					mat-icon-button
				>
					<mat-icon>refresh</mat-icon>
				</button>
			</div>
		</div>
		<ng-template #reloadCalLoading>
			<div
				class="flex flex-col items-center justify-center"
				style="width: 40px; height: 40px"
			>
				<mat-progress-spinner
					[diameter]="20"
					[mode]="'indeterminate'"
					[strokeWidth]="2"
					color="primary"
				></mat-progress-spinner>
			</div>
		</ng-template>
	</ng-template>
</tg-toolbar>
<div class="container-wrapper">
	<div class="container-content calendar-items flex flex-col items-stretch justify-start pb-0">
		<div class="flex h-full justify-start">
			<!-- calendar -->
			<div class="flex flex-auto flex-col">
				<div class="mat-bg-3 mat-bd-b-8 flex flex-col pt-5">
					<mat-form-field
						appearance="fill"
						class="mx-6"
					>
						<mat-label translate>utils.search</mat-label>
						<input
							[formControl]="this.eventFilterSearch"
							matInput
						>
						<button
							[matMenuTriggerFor]="eventSearchFilterMenu"
							mat-icon-button
							matSuffix
							type="button"
						>
							<mat-icon>filter_list</mat-icon>
						</button>
					</mat-form-field>
				</div>
				<ng-container *ngIf="this.requestError$ | async as err">
					<div class="alert alert-danger rounded-0 flex flex-col">
						<small> {{ 'errors.server' | translate }}</small>
						<div
							*ngIf="err.isTimeout || !err.isAuthed"
							class="mt-1"
						>
							<button
								(click)="locationReload()"
								class="mat-button-small"
								mat-flat-button
							>
								{{ 'utils.reload' | translate }}
							</button>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="filteredEntries$ | async as entries">
					@if(entries.length > 0) {
					<ng-container>
						<div class="flex flex-row  gap-x-2 pl-6 pt-3 pb-1 mr-6">
							<button
								(click)="this.selectAll()"
								[matTooltip]=" 'feed.select-all-toggle' | translate"
								mat-icon-button
							>
								<mat-icon>select_all</mat-icon>
							</button>
							@if(this.selectedFeedEvents.value.length) {
							<button
								(click)="this.createMultipleTimes()"
								mat-raised-button
							>
								{{ 'feed.createEntries' | translate }}
							</button>
							<button
								(click)="this.multiToggleHide()"
								mat-raised-button
							>
								{{ 'feed.hideSelectedEvents' | translate }}
							</button>
							<button
								(click)="clearFeedSelection()"
								[matTooltip]="'feed.clearSelection' | translate"
								mat-raised-button
							>
								<mat-icon>close</mat-icon>
							</button>
							<mat-icon
								[matTooltip]="'timer.calendar.multiSelectionHint' | translate"
								class="!ml-auto"
							>
								info
							</mat-icon>
							}
						</div>
					</ng-container>
					}
					<div class="feed-container-wrapper">
						<div class="feed-container-content">
							<ng-container *ngIf="filteredEntries$ | async as entries">
								<ng-container
									*ngTemplateOutlet="(isLoading$ | async) ? loadingCards : entries.length > 0 ? entriesTemplate : noResultsTemplate; context: { entries: entries }"
								></ng-container>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
<ng-template
	#nullSubject
	let-entry
>
	<h3 class="entry-subject my-0 ml-1 truncate font-bold">{{ 'feed.emptySubject' | translate }}</h3>
</ng-template>
<ng-template
	#existSubject
	let-entry
>
	<h3
		[ngClass]="entry.booked ? '' : 'ml-9'"
		class="entry-subject my-0 truncate font-bold"
	>
		{{ entry.name }}
	</h3>
</ng-template>
<ng-template #loadingCards>
	<div class="calGroup">
		<!-- date indicator -->
		<div class="calGroupEntries">
			<!-- calendar entry -->
			<div class="calendar-items flex flex-col items-stretch justify-start">
				<ng-container *ngFor="let _i of [0, 0, 0, 0]; let ceLast = last">
					<mat-card class="calEntry calendar-item !py-1">
						<mat-card-content class="calEntryContent !px-3">
							<div class="flex flex-col gap-2">
								<div
									class="mat-skeleton"
									style="width: 150px"
								></div>
								<div
									class="mat-skeleton"
									style="width: 80px"
								></div>
								<div
									class="mat-skeleton"
									style="width: 180px"
								></div>
							</div>
						</mat-card-content>
					</mat-card>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #calendarEntryExample>
	<mat-card class="calEntry calEntryExample">
		<div class="calEntryExamplePan"><mat-icon>pan_tool</mat-icon></div>
		<mat-card-content>
			<div class="calEntryContent flex flex-row items-center justify-start">
				<div class="flex flex-grow flex-col items-start justify-start gap-[2px]">
					<div class="flex flex-row items-center justify-start gap-2">
						<h4 class="my-0 ml-1">{{ 'utils.example' | translate }}</h4>
					</div>
					<small class="mat-hint ml-1">{{ 'feed.draggable-notice' | translate }}</small>
				</div>
				<div class="flex-grow"></div>
				<div class="flex items-center"><mat-icon>branding_watermark</mat-icon></div>
				<div
					(mousedown)="$event.stopPropagation()"
					class="flex flex-col justify-center"
				>
					<button
						disabled
						mat-icon-button
					>
						<mat-icon>more_vert</mat-icon>
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</ng-template>
<router-outlet></router-outlet>
<mat-menu
	#eventSearchFilterMenu="matMenu"
	class="event-filter !pb-2 !pt-0"
>
	<ng-template
		let-data
		matMenuContent
	>
		<mat-list
			(click)="$event.stopPropagation()"
			class="event-filter-list !py-0"
		>
			<ng-container *ngIf="availableScopes$ | async as enabledScopes">
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.Calendar)"
					[checked]="enabledScopes.enabled(scopes.Calendar)"
					[title]="'account-scope.' + scopes.Calendar"
					*ngIf="enabledScopes.includes(scopes.Calendar)"
					image="/assets/img/logos/calendar_logo.png"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.OutlookTasks)"
					[checked]="enabledScopes.enabled(scopes.OutlookTasks)"
					[title]="'account-scope.' + scopes.OutlookTasks"
					*ngIf="enabledScopes.includes(scopes.OutlookTasks)"
					image="/assets/img/logos/todo_logo.png"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.RecentFiles)"
					[checked]="enabledScopes.enabled(scopes.RecentFiles)"
					[title]="'account-scope.' + scopes.RecentFiles"
					*ngIf="enabledScopes.includes(scopes.RecentFiles)"
					image="/assets/svg/office/onedrive_48x1.svg"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.Sites)"
					[checked]="enabledScopes.enabled(scopes.Sites)"
					[title]="'account-scope.' + scopes.Sites"
					*ngIf="enabledScopes.includes(scopes.Sites)"
					image="/assets/svg/office/sharepoint_48x1.svg"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.Messages)"
					[checked]="enabledScopes.enabled(scopes.Messages)"
					[title]="'account-scope.' + scopes.Messages"
					*ngIf="enabledScopes.includes(scopes.Messages)"
					image="https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product-fluent/png/outlook_48x1.png"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.Groups)"
					[checked]="enabledScopes.enabled(scopes.Groups)"
					[title]="'account-scope.' + scopes.Groups"
					*ngIf="enabledScopes.includes(scopes.Groups)"
					image="/assets/img/logos/planer_logo.png"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scopes.DevOpsOnline)"
					[checked]="enabledScopes.enabled(scopes.DevOpsOnline)"
					*ngIf="enabledScopes.includes(scopes.DevOpsOnline)"
					image="/assets/img/logos/devops_logo.png"
					title="account-scope.DevOpsOnline.ReadBasic"
				></app-feed-filter-event-item>
				<app-feed-filter-event-item
					(change)="this.toggleFilterScope(scope)"
					[checked]="enabledScopes.enabled(scope)"
					[title]="'account-scope.' + scope"
					*ngIf="enabledScopes.includes(scopes.TeamsCalls) && scopes.TeamsCalls as scope"
					image="/assets/svg/icons/teams.svg"
				></app-feed-filter-event-item>
				<ng-container *ngIf="this.availableScopes$custom | async as customScopes">
					<mat-divider
						class="my-2"
						inline
					></mat-divider>
					<h4 mat-subheader>Custom Types</h4>
					<app-feed-filter-event-item
						(change)="toggleFilterScope(scope.key)"
						[checked]="enabledScopes.enabled(scope.key)"
						[title]="scope.key | parseCustomScope"
						*ngFor="let scope of customScopes.scopes"
					></app-feed-filter-event-item>
				</ng-container>
			</ng-container>
			<mat-divider
				class="my-2"
				inline
			></mat-divider>
			<div
				[routerLink]="['feed-scopes']"
				class="cursor-pointer"
				matRipple
			>
				<div
					class="event-filter-item flex flex-row items-center justify-start gap-3"
					mat-list-item
				>
					<span translate>account-scope.connect</span>
				</div>
			</div>
		</mat-list>
	</ng-template>
</mat-menu>
<mat-menu #projectMenu>
	<ng-template
		let-project="project"
		matMenuContent
	>
		<button
			(click)="this.togglePinProject(project.id)"
			mat-menu-item
		>
			<mat-icon inline>star</mat-icon>
			{{ (this.isProjectPinned(project.id) ? 'project.fav-disable' : 'project.fav-enable') | translate }}
		</button>
		<a
			[routerLink]="['/settings/projects', project.id]"
			*ngIf="!project.useAsDefault"
			mat-menu-item
		>
			<mat-icon inline>folder</mat-icon>
			{{ 'project.open' | translate }}
		</a>
	</ng-template>
</mat-menu>
<tg-day-picker-popover
	(viewDateChange)="updateRange($event)"
	[min]="minRangeStart"
	[rangeType]="rangeType"
	[viewDate]="viewDate$ | async"
	#dayPickerPopover
></tg-day-picker-popover>
<ng-template #noResultsTemplate>
	<div
		*ngIf="!(isLoading$ | async)"
		class="flex h-32 flex-col items-stretch justify-center gap-2"
	>
		<div class="flex flex-row items-center justify-center gap-2">
			<span
				*ngIf="viewDate$ | async as vd"
				class="mat-hint"
				>{{ vd.start | formatDate: 'PP' }}- {{ vd.end | formatDate: 'PP' }}</span
			>
		</div>
		<span
			*ngIf="this.eventFilterSearch.value"
			class="text-center"
			translate
			>feed.search.noitems</span
		>
		<span
			*ngIf="!this.eventFilterSearch.value"
			class="text-center"
			translate
			>utils.noitems</span
		>
	</div>
</ng-template>
<ng-template
	#entriesTemplate
	let-entries="entries"
>
	<ng-container
		*ngFor="let entry of entries; let ceIndex = index; let ceFirst = first; let ceLast = last; trackBy: trackId"
	>
		<mat-card
			(click)="drop($event, { data: entry }, checkbox)"
			(contextmenu)="openFeedEntryContextMenu($event, feedEntryMenuTrigger, { entry: entry })"
			class="calEntry calendar-item cursor-pointer !py-0"
		>
			<mat-card-content>
				<div class="calEntryContent flex flex-row items-center justify-start">
					<div class="flex-text flex flex-grow flex-col items-start justify-start gap-2 mt-2">
						<div class="flex-text flex flex-row items-center justify-start gap-2 pb-1">
							<div
								*ngIf="entry.booked"
								class="ml-1 flex-none leading-none"
							>
								<mat-icon
									class="mat-icon-complete"
									inline
								>
									check
								</mat-icon>
							</div>
							<ng-container
								*ngTemplateOutlet="entry.name ? existSubject : nullSubject; context: { $implicit: entry }"
							></ng-container>
						</div>
						<div class="flex flex-row">
							<div>
								<mat-checkbox
									(change)="addToMultiselected($event.checked, entry)"
									(click)="$event.stopPropagation()"
									[(ngModel)]="entry.selected"
									[checked]="!selectedFeedEvents.value.length ? false : checkbox.checked"
									#checkbox
									class="px-2"
								></mat-checkbox>
							</div>

							<div class="flex-text flex flex-col items-center justify-start gap-2 pb-1">
								<div
									*ngIf="entry.description as desc"
									class="mat-fill-card-content px-1 mb-2"
								>
									{{ desc | parseFeedDescription | truncate: 120 }}
								</div>
								<div class="flex w-full flex-row items-center justify-start gap-1.5">
									<ng-container *ngIf="!entry.isAllDay">
										<div
											class="badge flex flex-row items-center justify-start gap-1.5"
											ngClass.lt-sm="badge-sm"
										>
											<span
												>{{ entry.start | dfnsParseIso | dfnsFormat: 'dd. MMMM - EEEE' }},</span
											>
											<span>{{ entry.start | dfnsParseIso | formatDate: 'time' }}</span>
											<span>-</span>
											<span>{{ entry.end | dfnsParseIso | formatDate: 'time' }}</span>
										</div>
									</ng-container>
									<ng-container *ngIf="entry.isAllDay">
										<div class="badge flex flex-row items-center justify-start gap-1.5">
											{{ 'feed.all-day' | translate }}
										</div>
									</ng-container>
									<div
										*ngIf="entry.calendar as calendar"
										class="badge flex flex-row items-center justify-start gap-1.5"
									>
										<div
											[style.backgroundColor]="color"
											*ngIf="calendar.color as color"
											class="rounded-circle -mt-px mr-1 h-3 w-3"
										></div>
										<span>{{ calendar.name }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-row self-start mt-5">
						<div class="flex flex-shrink-0 items-center">
							<img
								[src]="entry.iconUrl"
								*ngIf="entry.iconUrl != null; else msIcon"
								style="width: 32px"
							>
							<ng-template #msIcon>
								<ms-icon
									[icon]="entry.icon"
									style="font-size: 32px; height: 32px; width: 32px"
								></ms-icon>
							</ng-template>
						</div>
						<div
							(click)="$event.stopPropagation()"
							(mousedown)="$event.stopPropagation()"
							class="flex flex-shrink-0 flex-col justify-center"
						>
							<button
								(click)="
					openFeedEntryContextMenu($event, feedEntryMenuTrigger, {
					entry: entry,
					})
				"
								mat-icon-button
							>
								<mat-icon>more_vert</mat-icon>
							</button>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</ng-container>
</ng-template>
<mat-menu
	#feedEntrySuggestionsMenu
	class="flex-mat-menu"
>
	<ng-template
		let-feedItem="entry"
		let-suggestions="suggestions"
		matMenuContent
	>
		<div class="flex flex-col gap-2">
			<ng-container *ngFor="let project of suggestions | slice: 0 : 10; trackBy: trackId">
				<button
					(click)="submitFeedItem(feedItem, project.id, task, !!$event.ctrlKey)"
					[disabled]="isLoading"
					*ngFor="let task of project.tasks; trackBy: trackId"
					mat-menu-item
				>
					<div class="flex flex-col space-y-1">
						<span>{{ task.id === '_internal' ? (task.name | translate) : task.name }}</span>
						<span class="mat-hint text-xs">{{
							project | defaultEntityTranslate: 'project' : 'project.none'
						}}</span>
					</div>
				</button>
			</ng-container>
		</div>
	</ng-template>
</mat-menu>
<mat-menu #feedEntryContextMenu>
	<ng-template
		let-entry="entry"
		let-suggestions="suggestions"
		let-suggestionsLoading="suggestionsLoading"
		matMenuContent
	>
		<div class="flex flex-col">
			<a
				[disabled]="!entry.link"
				[href]="entry.link"
				mat-menu-item
				target="_blank"
				>{{
					'feed.entry.open' | translate
				}}</a
			>
			<ng-container *ngIf="!suggestionsLoading; else suggestionsLoadingTemplate">
				<button
					[disabled]="!suggestions"
					[matMenuTriggerData]="{ suggestions: suggestions, entry: entry }"
					[matMenuTriggerFor]="feedEntrySuggestionsMenu"
					mat-menu-item
				>
					{{ 'utils.suggestions' | translate }}
				</button>
			</ng-container>
			<button
				(click)="toggleHide(entry)"
				[disabled]="hideLoading"
				mat-menu-item
			>
				{{ 'feed.entry.hide' | translate }}
			</button>
		</div>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="feedEntryContextMenu"
	[style.left]="feedEntryMenuPosition.x"
	[style.top]="feedEntryMenuPosition.y"
	#feedEntryMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<ng-template #suggestionsLoadingTemplate>
	<button
		(click)="$event.preventDefault()"
		[disabled]="true"
		mat-menu-item
	>
		<div class="flex items-center space-x-2">
			<mat-spinner
				[diameter]="16"
				[strokeWidth]="2"
				mode="indeterminate"
			></mat-spinner>
			<div class="flex items-center space-x-2">{{ 'utils.suggestions' | translate }}</div>
		</div>
	</button>
</ng-template>
